import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getMe, getTokenLocalStorage } from '../actions/auth';
import { RootState } from '../reducers';
import { IAuthState } from '../reducers/auth';

const RedirectRoutePerRole = () => {
  const dispatch = useDispatch();
  const { authUser, isAuthenticated, loading } = useSelector(
    (state: RootState) => state.auth as IAuthState
  );
  const { accessToken } = getTokenLocalStorage();

  console.log(
    'RedirectRoutePerRole - authUser:',
    authUser,
    'isAuthenticated:',
    isAuthenticated,
    'loading:',
    loading,
    'accessToken:',
    !!accessToken
  );

  useEffect(() => {
    if (!!accessToken) {
      dispatch(getMe());
    }
  }, [accessToken, dispatch]);

  if (authUser) {
    const { role } = authUser;
    console.log('RedirectRoutePerRole - Navigating to /order for role:', role);
    return <Navigate to="/order" replace />;
  }

  console.log('RedirectRoutePerRole - No authUser, navigating to /login');
  return <Navigate to="/login" />;
};

export default RedirectRoutePerRole;
